/**
 * Search Toggle Module
 * Handles dashboard search type switching between docs and news.
 */
function initSearchToggle() {
  if (typeof window.setSearchType !== 'undefined') return;

  window.setSearchType = function (type) {
    const docsBtn = document.getElementById('btn-docs');
    const newsBtn = document.getElementById('btn-news');

    if (!docsBtn || !newsBtn) return;

    const activeClasses = ['bg-primary', 'text-white'];
    const inactiveClasses = [
      'text-gray-600',
      'dark:text-gray-400',
      'hover:text-primary',
      'dark:hover:text-white',
      'bg-gray-200',
      'dark:bg-dark-border',
    ];

    const [active, inactive] = type === 'docs' ? [docsBtn, newsBtn] : [newsBtn, docsBtn];

    activeClasses.forEach((cls) => active.classList.add(cls));
    inactiveClasses.forEach((cls) => active.classList.remove(cls));

    activeClasses.forEach((cls) => inactive.classList.remove(cls));
    inactiveClasses.forEach((cls) => inactive.classList.add(cls));
  };
}
